<template>
  <div class="bg">
    <div class="content">
      <div class="page-header">
        <el-page-header @back="goBack"></el-page-header>
        <span id="header-title">我的收藏</span>
      </div>
      <div class="main">
        <el-tabs type="card" :tab-position=" 'left' " class="tabs">
          <el-tab-pane label="检索条件收藏">
            <div class="info">
              
            </div>
          </el-tab-pane>
          <el-tab-pane label="专利收藏">
            <div class="info">
              
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'account',
    data() {
      return {
        attribute: [
          {
            name: 'username',
            label: '用户名'
          },
          {
            name: 'email',
            label: '邮箱'
          },
          {
            name: 'company_name',
            label: '公司名'
          },
          {
            name: 'search_time',
            label: '检索次数'
          },
          {
            name: 'download_time',
            label: '下载次数'
          },
          {
            name: 'expiration_date',
            label: '到期时间'
          }
        ],
        user: {
          username: "manager1",
          email: "564785000@gmail.com",
          company_name: "",
          search_time: "26/50000",
          download_time: "4/50000",
          expiration_date: "2027-12-08"
        }
      }
    },
    mounted: function () {},
    methods: {
      goBack() {
        window.history.back();
      },
    }
  }
</script>

<style scoped>
  .bg {
    background-color: #f7faff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .content{
    width: calc(100% - 400px);
    max-width: 1920px;
    height: calc(100vh - 48px);
    flex-direction: column;
    margin: 0 200px 0 200px;
  }

  .page-header {
    height: 49px;
    width: 100%;
    border-bottom: 1px solid #e5e6eb;
  }
  .el-page-header {
    padding-top: 10px;
    width: 94px;
    float: left;
  }
  .page-header #header-title {
    font-size: 18px;
    font-weight: bold;
    float: left;
    margin: 9px 40px 0 0;
  }

  .main {
    overflow: auto;
    height: calc(100% - 80px);
    width: 100%;
    padding-top: 30px;
  }

  .info {
    overflow: auto;
    background-color: #FFFFFF;
    width: calc(100% - 100px);
    height: calc(100% - 160px);
    padding: 80px 0 80px 100px;
  }
</style>
